import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LanguageService } from 'src/app/services/language.service';


@Component({
  selector: 'app-about-dialog',
  templateUrl: './about-dialog.component.html',
  styleUrls: ['./about-dialog.component.scss'],
})
export class AboutDialogComponent implements OnInit {

  type: string;
  name: string;
  logo: string;
  additionalData: any[];
  website: any;
  description: string;
  standards: string[];

  constructor(
    private languageService: LanguageService,
    private dialogRef: MatDialogRef<AboutDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data) {
      this.type = data.type;
      this.name = data.name;
      this.logo = data.logo;
      this.additionalData = data.additionalData;
      this.website = data.website;
      this.description = data.description;
      this.standards = data.standards;
    }

  ngOnInit() {}

  closeDialog() {
    this.dialogRef.close({ event: 'close', data: [] });
  }

  get currentLanguage() {
    return this.languageService.getUserUsedLanguage();
  }
}
